import { APPSTORE_URL, PLAYSTORE_URL } from "../../constants/Constants";

const handleOpenApp = () => {
  try {
    if (typeof window === "undefined") return;
    const isIPhone = /iPhone/i.test(navigator.userAgent);
    window.open(isIPhone ? APPSTORE_URL : PLAYSTORE_URL);
  } catch (error) {
    console.error(error);
  }
};

export default handleOpenApp;
